<template>
  <side-bar v-show="PostCreateSidebar" position-right class="z-10 max-w25">
    <div class="flex sidebar-topfixpart bg-primary justify-between p-4">
      <h2 class="h2-class font-semibold text-white">ADD TAGS</h2>

      <feather-icon
        icon="XIcon"
        @click="closeSidebar"
        class="cursor-pointer text-white"
        svgClasses="w-6"
      ></feather-icon>
    </div>
    <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
      <b-form role="form" @submit.prevent="handleSubmit(addtags)">
        <div class="p-4">
          <div class="mb-2">
            <p class="font-semibold text-sm mb-2">
              Page:<span class="text-danger pl-1">*</span>
            </p>
            <b-form-group>
              <b-form-select
                v-model="selectedPageCategory"
                :rules="{ required: true }"
                @change="getfiltersbycategory(selectedPageCategory)"
              >
                <b-form-select-option value="" disabled selected>
                  Please select a Page</b-form-select-option
                >
                <b-form-select-option
                  v-for="pageCategory in pageCategories"
                  :value="pageCategory"
                  :key="pageCategory._id"
                  v-if="pageCategory.name !== 'News'"
                  >{{ pageCategory.name }}</b-form-select-option
                >
              </b-form-select>
            </b-form-group>
          </div>
          <div class="mb-2">
            <p class="font-semibold text-sm mb-2">
              Filter:<span class="text-danger pl-1">*</span>
            </p>
            <b-form-group>
              <b-form-select
                v-model="selectedfilter"
                :rules="{ required: true }"
              >
                <b-form-select-option value="" disabled selected>
                  Please select a Filter</b-form-select-option
                >
                <b-form-select-option
                  v-for="filter in filters"
                  :value="filter._id"
                  :key="filter._id"
                  required
                  >{{ filter.name }}</b-form-select-option
                >
              </b-form-select>
            </b-form-group>
          </div>
          <div class="mb-4">
            <p class="font-semibold text-sm mb-2">
              Tags<span class="text-danger pl-1">*</span>
            </p>
            <b-input
              placeholder="Enter  Tags..."
              v-model="tags"
              :rules="{ required: true }"
            />
          </div>
        </div>
        <footer class="w-full mb-10 px-4">
          <base-button
            block
            native-type="submit"
            class="rounded font-semibold"
            type="primary"
            >Add</base-button
          >
        </footer>
      </b-form>
    </validation-observer>
  </side-bar>
</template>
<script>
import { mapState } from "vuex";
export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: false,
    },
  },

  data() {
    return {
      tags: "",
      selectedPageCategory: "",
      selectedfilter: "",
      name: "",
      categories: [],
    };
  },
  computed: {
    ...mapState("cms", {
      pageCategories: "pageCategories",
      filters: "filters",
    }),
    ...mapState("UI", ["PostCreateSidebar"]),
  },
  methods: {
    async addtags() {
      const payload = {
        name: this.tags,
        filter: this.selectedfilter,
      };
      if (
        this.tags.trim() != "" &&
        this.selectedfilter.trim() !== "" &&
        this.selectedPageCategory !== ""
      ) {
        await this.$store.dispatch("cmstag/addTag", payload);
        this.$store.commit("UI/TOGGLE_POST_CREATE_SIDEBAR", true);
        this.$swal.fire({
          text: "Tag successfully added",
          icon: "success",
          confirmButtonText: "Okay",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        // window.location.reload();
        this.closeSidebar();
        this.reset();
        let payload2 = {
          offset: (this.currentPage - 1) * 5,
          limit: 5,
        };
        let tags = await this.$store.dispatch("cmstag/getTags", payload2);
      } else {
        this.$swal.fire({
          icon: "info",
          text: "All fields are mandatory",
          confirmButtonText: "Okay",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
      }
    },

    closeSidebar() {
      this.$store.commit("UI/TOGGLE_POST_CREATE_SIDEBAR", false);
    },
    async getfiltersbycategory(payload) {
      await this.$store.dispatch("cms/getfilterbycategory", {
        categoryPage: payload._id,
      });
    },
    reset() {
      this.tags = "";
      this.selectedPageCategory = "";
      this.selectedfilter = "";
      this.name = "";
    },
  },
};
</script>
